import { connect } from 'react-redux';
import { compose, lifecycle, withState, withHandlers } from 'recompose';
import _findIndex from 'lodash/findIndex';
import _indexOf from 'lodash/indexOf';
import _filter from 'lodash/filter';
import { statusSelector, hide } from 'store/modules/modal';
import { fetchCampaigns } from 'routes/Dashboard/Home/modules';
import { http } from 'helpers/axios';
import KeyManagement from 'components/Modal/KeyManagement';
import { createSelector } from 'reselect';

const mapStateToProps = createSelector(statusSelector, status => ({ status }));

const mapDispatchToProps = {
  hide,
  fetchCampaigns,
};

const $lifecycle = lifecycle({
  componentDidMount() {
    http
      .get('/buckets')
      .get('data')
      .then(({ docs }) => {
        const { keys } = this.props.campaign;
        const checked = _filter(
          docs,
          r => _indexOf(keys, r._id.toString()) !== -1
        );

        this.props.setKeys(docs);
        this.props.setChecked(checked);
        this.props.setLoaded(true);
      });
  },
});

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withState('checked', 'setChecked', []),
  withState('keys', 'setKeys', []),
  withState('loaded', 'setLoaded', false),
  withHandlers({
    handleToggle: props => key => () => {
      const { checked } = props;
      const currentIndex = _findIndex(checked, ['_id', key._id]);
      const newChecked = [...checked];

      if (currentIndex === -1) {
        newChecked.push(key);
      } else {
        newChecked.splice(currentIndex, 1);
      }

      props.setChecked(newChecked);
    },
    handleSubmit: props => () => {
      const { campaign, checked } = props;
      const keys = checked.map(key => key._id);

      http.put(`/campaigns/${campaign._id}`, { keys }).then(() => {
        props.hide();
        props.fetchCampaigns();
      });
    },
  }),
  $lifecycle
);

export default enhance(KeyManagement);
